import React from 'react';

const BrokenError = ({ fill = '#E6E5E8' }: { fill?: string }): JSX.Element => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8849 3.03347C12.5389 2.37947 11.4629 2.37947 11.1169 3.03347L2.11694 20.0335C2.03592 20.1858 1.99575 20.3566 2.00036 20.5291C2.00496 20.7016 2.05417 20.87 2.14319 21.0178C2.23221 21.1657 2.35801 21.2879 2.50833 21.3727C2.65865 21.4574 2.82837 21.5018 3.00094 21.5015H21.0009C21.1734 21.5018 21.343 21.4575 21.4932 21.3728C21.6434 21.2881 21.7691 21.1659 21.8581 21.0181C21.947 20.8704 21.9961 20.7021 22.0007 20.5297C22.0052 20.3573 21.965 20.1867 21.8839 20.0345L12.8849 3.03347ZM13.0009 18.5015H11.0009V16.5015H13.0009V18.5015ZM11.0009 14.5015V9.50147H13.0009L13.0019 14.5015H11.0009Z"
      fill={fill}
    />
  </svg>
);

export default BrokenError;
